module.exports = __webpack_public_path__ + "img/foto-s-zanatiy-4.2ce47dab.png";